import { render, staticRenderFns } from "./approvalOpinionShortcuts.vue?vue&type=template&id=672e38ee&scoped=true"
import script from "./approvalOpinionShortcuts.vue?vue&type=script&lang=js"
export * from "./approvalOpinionShortcuts.vue?vue&type=script&lang=js"
import style0 from "./approvalOpinionShortcuts.vue?vue&type=style&index=0&id=672e38ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e38ee",
  null
  
)

export default component.exports